import { Card, CardContent, CardHeader, makeStyles , Table, TableBody, TableCell, TableRow, TableFooter, Typography, Chip} from '@material-ui/core';
import moment from "moment-timezone";
import React, { useEffect, useMemo, useState } from 'react';
import ReactJson from 'react-json-view';
import { localizeCurrency } from 'util/localizeFormat';

const useStyles = makeStyles((theme) => {
  return {}
})
const PaymentSummary = ({booking, transaction}) => {
  const classes = useStyles()
  return (
    <Card>
      <CardHeader title="Payment Transaction"/>
      <CardContent>
        <Typography variant="body1" color="textSecondary" component="p">Transaction Date: {moment(transaction?.timestamp).format('LL LT')}</Typography>
        {/* <Typography variant="body1">Status: <Chip size="small" label={transaction?.status} /></Typography> */}
        <Table>
          <TableBody>
            <TableRow>
              <TableCell align='start'>Total</TableCell>
              <TableCell align='right' variant="head">{localizeCurrency(transaction?.amount)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell align='start'>Credits</TableCell>
              <TableCell align='right' variant="head">{localizeCurrency(transaction?.credits)}</TableCell>
            </TableRow>
            </TableBody>
            <TableFooter>
            </TableFooter>
        </Table>

      </CardContent>
    </Card>
  )
}

export {PaymentSummary}